import {Component, Input, OnInit} from '@angular/core';
import {ChartOptions} from "../../../components/dashboard/apex-hospital-chart/apex-hospital-chart.component";

@Component({
  selector: 'app-apex-bar-graph',
  templateUrl: './apex-bar-graph.component.html',
  styleUrls: ['./apex-bar-graph.component.scss']
})
export class ApexBarGraphComponent implements OnInit {
  public areaChartOptions!: Partial<ChartOptions>;
  @Input() mLabels!: string[]
  @Input() mCount!: any[]
  @Input() title!: string
  constructor() {
  }
  ngOnInit(): void {
    this.areaChart()
  }
  private areaChart() {
    this.areaChartOptions = {
      series: [
        {
          name: this.title,
          data: this.mCount,
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
          show: false,
        },
        foreColor: '#9aa0ac',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          distributed: true, // Ensure bars are colored individually
        }
      },
      colors: ['#4379F2', '#EF5A6F', '#387F39', '#6439FF', '#FF885B', '#48CFCB', '#FABC3F', '#A28B55', '#921A40',
        '#85f76c', '#8E44AD', '#1F8A70', '#b58561', '#2C3E50', '#E74C3C', '#9B59B6', '#3498DB', '#F1C40F',
        '#16A085', '#D35400', '#1a628f', '#C0392B', '#27AE60', '#BDC3C7', '#FF6347', '#FF1493', '#6A5ACD', '#FFD700'],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: this.mLabels
        // categories: [
        //     '2018-09-19',
        //     '2018-09-20',
        //     '2018-09-21',
        //     '2018-09-22',
        //     '2018-09-23',
        //     '2018-09-24',
        //     '2018-09-25',
        // ],
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },

      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
  }

}
